<template>
  <span class="d-inline-block">
    <b-button
        ref="btn"
        v-b-tooltip.hover
        :title="tooltipTitle"
        :variant="variant"
        :size="size"
        class="btn-icon"
        :disabled="isLoading"
        @click="onClick"
    >
      <b-spinner v-if="isLoading" small/>
      <feather-icon v-else icon="ZapIcon"/>
    </b-button>
    <b-popover
        :target="() => $refs.btn"
        :show.sync="popoverShow"
        triggers="manual"
        placement="bottom"
    >
      <template #title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Оригинал по версии ИИ</span>
          <b-button
              variant="flat-secondary"
              class="btn-icon p-0 ml-1"
              size="sm"
              @click="closePopover"
          >
            <feather-icon icon="XIcon"/>
          </b-button>
        </div>
      </template>
      <div style="min-width: 220px; max-width: 320px;">
        <div v-if="isLoading" class="d-flex align-items-center">
          <b-spinner small class="mr-50"/>
          <span>Определяем оригинал…</span>
        </div>
        <div v-else-if="errorMessage">
          <div class="text-danger mb-1">{{ errorMessage }}</div>
          <b-button variant="primary" size="sm" @click="onClick">Повторить</b-button>
        </div>
        <div v-else-if="result">
          <div v-if="result.confidence === 'high' && result.is_original === false">
            Оригинал: <strong>{{ result.original_artist }} — {{ result.original_title }}</strong>
          </div>
          <div v-else-if="result.confidence === 'high' && result.is_original === true">
            Это и есть оригинал ({{ result.original_artist }} — {{ result.original_title }})
          </div>
          <div v-else class="text-muted">
            Не удалось уверенно определить оригинал
          </div>
          <b-badge
              v-if="result.confidence"
              :variant="result.confidence === 'high' ? 'light-success' : 'light-secondary'"
              class="mt-50"
          >{{ result.confidence === 'high' ? 'уверенно' : 'неуверенно' }}</b-badge>
          <div v-if="result.sources && result.sources.length" class="mt-1">
            <small class="text-muted d-block mb-25">Источники:</small>
            <div
                v-for="(source, index) in result.sources"
                :key="index"
                class="text-truncate"
            >
              <b-link
                  :href="source.uri"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="font-small-2"
              >
                <feather-icon icon="ExternalLinkIcon" size="12" class="mr-25"/>{{ source.title || source.uri }}
              </b-link>
            </div>
          </div>
          <div v-if="allowApply && result.original_title" class="mt-1">
            <b-button variant="outline-primary" size="sm" @click="onApply">Подставить</b-button>
          </div>
        </div>
      </div>
    </b-popover>
  </span>
</template>

<script>
import {
  BButton,
  BPopover,
  BSpinner,
  BBadge,
  BLink,
  VBTooltip,
} from 'bootstrap-vue'
import {ref, computed, getCurrentInstance} from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    BButton,
    BPopover,
    BSpinner,
    BBadge,
    BLink,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    query: {
      type: String,
      required: true,
    },
    storeNamespace: {
      type: String,
      default: 'artists',
    },
    allowApply: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
    variant: {
      type: String,
      default: 'flat-primary',
    },
  },
  setup(props, {emit}) {
    const instance = getCurrentInstance()
    const btn = ref(null)
    const isLoading = ref(false)
    const result = ref(null)
    const errorMessage = ref(null)
    const popoverShow = ref(false)

    // Пустой title отключает тултип, пока открыт поповер
    const tooltipTitle = computed(() => (popoverShow.value ? '' : 'Определить оригинал через ИИ'))

    const hideTooltip = () => {
      const vm = instance && instance.proxy
      if (vm && vm.$root) vm.$root.$emit('bv::hide::tooltip')
    }

    const onClick = async () => {
      if (isLoading.value) return
      const q = (props.query || '').trim()
      result.value = null
      errorMessage.value = null
      popoverShow.value = true
      hideTooltip()
      if (q.length < 3 || q.length > 300) {
        errorMessage.value = 'Запрос должен быть от 3 до 300 символов'
        return
      }
      isLoading.value = true
      try {
        const res = await store.dispatch(`${props.storeNamespace}/findTrackOriginal`, {query: q})
        result.value = res.data
      } catch (error) {
        const data = error.response && error.response.data
        if (data && data.errors && data.errors.query && data.errors.query.length) {
          errorMessage.value = data.errors.query[0]
        } else {
          errorMessage.value = (data && data.message) || 'Не удалось определить оригинал'
        }
      } finally {
        isLoading.value = false
      }
    }

    const onApply = () => {
      if (!result.value) return
      emit('apply', {
        original_artist: result.value.original_artist,
        original_title: result.value.original_title,
      })
      popoverShow.value = false
    }

    const closePopover = () => {
      popoverShow.value = false
    }

    return {
      btn,
      isLoading,
      result,
      errorMessage,
      popoverShow,
      tooltipTitle,
      onClick,
      onApply,
      closePopover,
    }
  },
}
</script>
